import { createFileRoute } from '@tanstack/react-router'
import { FormatConverterTool } from '~/features/ai-studio/components'

export const Route = createFileRoute('/dashboard/ai-studio/format-converter')({
  component: FormatConverterTool,
})
